import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import './LandingPage.css';
import './LandingPage2.css';
import Img1 from './assets/Img1.jpg';
import Img2 from './assets/Img0.jpg';
import Img3 from './assets/Img3.jpg';
import Img4 from './assets/Img4.jpg';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

function LandingPage() {
  const [showPopup, setShowPopup] = useState(false);

  

  return (
    <div className='Entire-Landing'>

      <Navbar/>
      <div className='mid-part-of-landing-page'>
        <div className='mid-text-1'>Welcome to Engineering Cubes</div>
        <div className='mid-text-2'>We are happy to have you on our website. On here you will be able to see many of our great projects. We hope you enjoy your stay !</div>
        <img src={Img1} className='mid-image-1' alt="Main project"/>

        <div className='mid-text-3'>Services that we provide</div>

        <div className='services-that-we-provide'>
          <div>
            <img src={Img2} className='mid-image-2' alt="Construction"/>
            <div>
              <div className='mid-image-text-title'>Construction</div>
              <div className='mid-image-text'>We will help build you the house of your dreams!</div>
            </div>
          </div>

          <div>
            <img src={Img3} className='mid-image-2' alt="MEP"/>
            <div>
              <div className='mid-image-text-title'>MEP</div>
              <div className='mid-image-text'>We will aid in the MEP process to the highest level of quality!</div>
            </div>
          </div>

          <div>
            <img src={Img4} className='mid-image-2' alt="Maintenance"/>
            <div>
              <div className='mid-image-text-title'>Maintenance</div>
              <div className='mid-image-text'>If you are running into some issues we can help maintain what you already have!</div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </div>
  )
}

export default LandingPage;